/* Quiz (design) — behaviour for sections/new-quiz.liquid.
   Reads the product catalogue from #nq-data and the few section settings it
   needs from #nq-config, both written by the section as JSON. Uses
   window.npCart (assets/np-chrome.js) for the actual cart/add.js call. */
(function () {
  var nqRoot = document.getElementById("nq");
  var main = document.getElementById("nq-main");
  var dataEl = document.getElementById("nq-data");
  var configEl = document.getElementById("nq-config");
  if (!nqRoot || !main || !dataEl) return;
  var P = {};
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var CFG = {};
  if (configEl) { try { CFG = JSON.parse(configEl.textContent) || {}; } catch (e) { CFG = {}; } }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var CURRENCY = CFG.currency || "GBP";
  var BUNDLE = CFG.bundleUrl || "/pages/build-a-bundle";

  /* the single source for the intro screen: whatever Liquid rendered into
     #nq-main on load. Re-used (not re-templated) whenever we come back to
     the intro, so there is only ever one copy of this markup. */
  var introHTML = main.innerHTML;

  /* ---- the design's questions, verbatim ---- */
  var Q = [
    { id: "goal", q: "What are you training for?", a: [
      { v: "strength", label: "Strength & size", sub: "Lifting, bodybuilding, powerlifting" },
      { v: "hyrox", label: "HYROX or CrossFit", sub: "Mixed strength and conditioning" },
      { v: "endurance", label: "Endurance", sub: "Running, cycling, triathlon" },
      { v: "health", label: "General health", sub: "Staying fit, feeling better" }
    ]},
    { id: "freq", q: "How many sessions a week?", a: [
      { v: "low", label: "1–3" }, { v: "mid", label: "4–5" }, { v: "high", label: "6 or more" }
    ]},
    { id: "diet", q: "Any dietary needs?", a: [
      { v: "any", label: "None" }, { v: "veggie", label: "Vegetarian" }, { v: "vegan", label: "Vegan / dairy-free" }
    ]},
    { id: "shake", q: "How do you like your protein?", a: [
      { v: "creamy", label: "Creamy shake", sub: "Milkshake-style, mixes with milk or water" },
      { v: "light", label: "Light and fruity", sub: "Juice-style, mixes with water" },
      { v: "none", label: "I get enough from food" }
    ]},
    { id: "caff", q: "Caffeine before training?", a: [
      { v: "yes", label: "Yes, bring it" }, { v: "no", label: "No caffeine" }
    ]},
    { id: "focus", q: "What do you most want help with?", hint: "Pick up to two.", multi: 2, a: [
      { v: "recovery", label: "Recovery & sleep" }, { v: "energy", label: "Energy in sessions" },
      { v: "hydration", label: "Hydration & cramping" }, { v: "strength", label: "Strength gains" }
    ]}
  ];
  var KEYS = "ABCD";
  var TITLES = { strength: "The strength stack", hyrox: "The hybrid stack", endurance: "The endurance stack", health: "The everyday stack" };
  /* one line per product, checked against each product's own label */
  var WHY = {
    whey: "Hits your daily protein target in one scoop.",
    clear: "Light, juice-style protein that's easy after hard sessions.",
    vegan: "Complete plant protein, dairy-free.",
    creatine: "5g a day for strength and power output.",
    hcreatine: "Creatine with electrolytes for mixed training.",
    hydra: "Replaces sodium lost in sweat.",
    energy: "Natural caffeine, L-theanine and electrolytes in one drink.",
    sleep: "Glycine and magnesium to wind down after late sessions.",
    sauce: "CrossFit pre-workout for sustained energy and focus. Contains caffeine.",
    carbs: "Fast 2:1 dextrose and fructose fuel for long sessions. No caffeine."
  };
  var CAFFEINATED = ["energy", "sauce"];
  var ANIM = !(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);

  function has(k) { return P[k] && P[k].available; }

  /* picker labels: only the option(s) that differ between variants, so the
     whey list reads "Banana", not "60 Servings / 1.8kg / Banana" */
  Object.keys(P).forEach(function (k) {
    var vs = P[k] && P[k].variants;
    if (!vs || vs.length < 2) return;
    var n = (vs[0].o || []).length, vary = [];
    for (var i = 0; i < n; i++) {
      var seen = {};
      vs.forEach(function (v) { seen[v.o[i]] = 1; });
      if (Object.keys(seen).length > 1) vary.push(i);
    }
    vs.forEach(function (v) { v.label = vary.length ? vary.map(function (i) { return v.o[i]; }).join(" / ") : v.t; });
  });

  function recommend(ans) {
    var f = ans.focus || [], score = {}, g = ans.goal;
    var add = function (k, n) { score[k] = (score[k] || 0) + n; };
    if (g === "strength") { add("creatine", 4); add("sauce", 1); }
    if (g === "hyrox") { add("hcreatine", 4); add("hydra", 2); add("energy", 1); }
    if (g === "endurance") { add("hydra", 4); add("energy", 2); }
    if (g === "health") { add("creatine", 2); add("sleep", 2); }
    if (ans.freq === "high") { add("sleep", 1); add("hydra", 1); }
    if (f.indexOf("recovery") > -1) add("sleep", 3);
    if (f.indexOf("energy") > -1) { if (ans.caff === "yes") add("energy", 3); else add("carbs", 3); }
    if (f.indexOf("hydration") > -1) add("hydra", 3);
    if (f.indexOf("strength") > -1) { if (g === "hyrox") add("hcreatine", 2); else add("creatine", 3); }
    if (ans.caff === "no") CAFFEINATED.forEach(function (k) { delete score[k]; });
    /* Hybrid Creatine is the only creatine-type product HYROX/CrossFit
       answers ever score; if it is out of stock, fall back to plain
       Creatine Monohydrate instead of dropping creatine entirely. */
    if (score.hcreatine && !has("hcreatine")) {
      if (!score.creatine) add("creatine", score.hcreatine);
      delete score.hcreatine;
    }
    var protein = null;
    if (ans.shake !== "none") protein = ans.diet === "vegan" ? "vegan" : ans.shake === "light" ? "clear" : "whey";
    if (protein && !has(protein)) protein = has("whey") && ans.diet !== "vegan" ? "whey" : null;
    var rest = Object.keys(score).filter(has).sort(function (a, b) { return score[b] - score[a]; }).slice(0, protein ? 2 : 3);
    return (protein ? [protein] : []).concat(rest);
  }

  var introOn = !!CFG.introOn;
  var autoAdv = !!CFG.autoAdv;
  var st = { step: introOn ? -1 : 0, ans: {}, plan: "sub", pick: {} };
  var advT = null;

  function esc(t) { return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(p) {
    try { return new Intl.NumberFormat("en-GB", { style: "currency", currency: CURRENCY }).format(p / 100); }
    catch (e) { return "£" + (p / 100).toFixed(2); }
  }

  var stepEl = document.getElementById("nq-step"), fill = document.getElementById("nq-fill");
  function chrome() {
    var s = st.step;
    stepEl.textContent = s < 0 ? "60 seconds" : s < Q.length ? (s + 1) + " / " + Q.length : "Done";
    fill.style.transform = "scaleX(" + (s < 0 ? 0 : Math.min(s, Q.length) / Q.length) + ")";
  }
  function swap(html) {
    main.innerHTML = html;
    var v = main.firstElementChild;
    if (v && !ANIM) v.classList.remove("nq-view");
    chrome();
  }

  function renderIntro(focusFirst) {
    swap(introHTML);
    if (focusFirst) {
      var h = main.querySelector(".nq-h1");
      if (h) h.focus({ preventScroll: true });
    }
  }

  function renderQ(focusFirst) {
    var q = Q[st.step], cur = st.ans[q.id];
    var on = function (v) { return q.multi ? (cur || []).indexOf(v) > -1 : cur === v; };
    var n = q.multi ? (cur || []).length : (cur ? 1 : 0);
    var html = '<div class="nq-q nq-view"><div class="nq-qhead"><span class="nq-kick">Question ' + (st.step + 1) + ' of ' + Q.length + '</span>' +
      '<h2 class="nq-h2" tabindex="-1">' + esc(q.q) + '</h2>' + (q.hint ? '<p class="nq-hint">' + esc(q.hint) + '</p>' : '') + '</div>' +
      '<div class="nq-answers" role="group" aria-label="' + esc(q.q) + '">';
    q.a.forEach(function (a, i) {
      html += '<button type="button" class="nq-a" data-v="' + esc(a.v) + '" aria-pressed="' + (on(a.v) ? "true" : "false") + '">' +
        '<span class="nq-key" aria-hidden="true">' + KEYS[i] + '</span><span class="nq-atext"><span class="nq-alabel">' + esc(a.label) + '</span>' +
        (a.sub ? '<span class="nq-asub">' + esc(a.sub) + '</span>' : '') + '</span></button>';
    });
    html += '</div><div class="nq-nav"><button type="button" class="nq-back" data-act="back">&larr; Back</button>';
    if (q.multi || !autoAdv) html += '<button type="button" class="nq-next" data-act="next"' + (n ? "" : " disabled") + '>' + (st.step === Q.length - 1 ? "See my stack &rarr;" : "Next &rarr;") + '</button>';
    else html += '<span class="nq-keys">Press a letter to choose</span>';
    html += '</div></div>';
    swap(html);
    var h = main.querySelector(".nq-h2");
    if (focusFirst && h) h.focus({ preventScroll: true });
  }

  /* the picked flavour, else the first one in stock, else the first one */
  function variantFor(k) {
    var vs = P[k].variants, id = st.pick[k], i;
    for (i = 0; i < vs.length; i++) if (vs[i].id === id && vs[i].a) return vs[i];
    for (i = 0; i < vs.length; i++) if (vs[i].a) return vs[i];
    return vs[0];
  }
  function subOn(k) { return st.plan === "sub" && P[k].plan && variantFor(k).sp > 0; }

  var ids = [];
  function renderNoStock() {
    var html = '<div class="nq-res nq-view"><div class="nq-qhead"><span class="nq-kick">Your stack</span>' +
      '<h2 class="nq-rtitle" tabindex="-1">Nothing in stock right now</h2>' +
      '<p class="nq-rwhy">Every product that matched your answers is currently out of stock. Retake the quiz for another option, or build your own bundle from what is available.</p></div>' +
      '<div class="nq-links"><button type="button" class="nq-link" data-act="restart">Retake the quiz</button><a class="nq-link" href="' + BUNDLE + '">Build your own bundle</a></div></div>';
    swap(html);
    var h = main.querySelector(".nq-rtitle");
    if (h) h.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }

  function renderResult() {
    ids = recommend(st.ans);
    if (!ids.length) { renderNoStock(); return; }
    var p0 = null;
    ids.forEach(function (k) { if (P[k].plan && (!p0 || P[k].pct > p0.pct)) p0 = P[k]; });
    var anySub = !!p0;
    if (!anySub) st.plan = "once";
    var html = '<div class="nq-res nq-view"><div class="nq-qhead"><span class="nq-kick">Your stack</span>' +
      '<h2 class="nq-rtitle" tabindex="-1">' + esc(TITLES[st.ans.goal] || "Your stack") + '</h2>' +
      '<p class="nq-rwhy">' + ids.length + ' products picked from your answers. Every one has a job; nothing’s in here to pad the basket.</p></div><div class="nq-rows">';
    ids.forEach(function (k) {
      var p = P[k];
      var rate = p.rating != null && p.reviews > 0
        ? '<span class="nps-rate" data-rate="' + p.id + '" data-rated><span class="nps-star">&#9733;</span><b>' + Number(p.rating).toFixed(1) + '</b><span>(' + p.reviews + ')</span></span>'
        : '<span class="nps-rate" data-rate="' + p.id + '" data-rate-name="' + esc(p.title) + '" data-rate-url="' + esc(p.url) + '"></span>';
      var flav = "";
      if (p.variants.length > 1) {
        flav = '<label class="nq-flav"><span class="visually-hidden">Flavour for ' + esc(p.name) + '</span><select data-k="' + k + '">';
        p.variants.forEach(function (v) {
          flav += '<option value="' + v.id + '"' + (v.a ? "" : " disabled") + (variantFor(k).id === v.id ? " selected" : "") + '>' + esc(v.label || v.t) + (v.a ? "" : " (sold out)") + '</option>';
        });
        flav += '</select></label>';
      }
      html += '<div class="nq-row" data-row="' + k + '">' +
        '<a class="nq-img" href="' + esc(p.url) + '" aria-hidden="true" tabindex="-1">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="96" height="96" loading="lazy">' : '') + '</a>' +
        '<div class="nq-info"><a class="nq-name" href="' + esc(p.url) + '">' + esc(p.name) + '</a>' +
        '<span class="nq-pwhy">' + esc(WHY[k] || "") + '</span>' + flav +
        '<span class="nq-rate">' + rate + '</span></div>' +
        '<div class="nq-price" data-price="' + k + '"></div></div>';
    });
    html += '</div><div class="nq-buy">';
    if (anySub) {
      var subLine = (p0.planName || "Subscribe and save") + (p0.min > 1 ? " · cancel after " + p0.min + " orders" : " · cancel anytime");
      var subPct = ids.map(function (k) { return P[k]; }).filter(function (p) { return p.plan && p.pct > 0; }).map(function (p) { return p.pct; });
      var samePct = subPct.length > 0 && subPct.every(function (v) { return v === subPct[0]; });
      var tag = p0.pct > 0 ? '<span class="nq-tag">Save ' + (samePct ? "" : "up to ") + Math.round(p0.pct) + '%</span>' : '';
      html += '<div class="nq-plans">' +
        '<button type="button" class="nq-plan" data-plan="sub" aria-pressed="' + (st.plan === "sub") + '"><span><b>Subscribe</b><small>' + esc(subLine) + '</small></span>' + tag + '</button>' +
        '<button type="button" class="nq-plan" data-plan="once" aria-pressed="' + (st.plan === "once") + '"><span><b>One-time</b><small>Single order</small></span></button></div>';
    }
    html += '<div class="nq-totrow"><div class="nq-tot"><span class="nq-totlabel" id="nq-totlabel"></span><span class="nq-totnum" id="nq-totnum"></span></div>' +
      '<button type="button" class="nq-add" id="nq-add" data-act="add">Add stack to cart</button></div><p class="nq-note" id="nq-note" hidden></p>' +
      '<span id="nq-total-status" class="visually-hidden" role="status" aria-live="polite"></span></div>' +
      '<div class="nq-links"><button type="button" class="nq-link" data-act="restart">Retake the quiz</button><a class="nq-link" href="' + BUNDLE + '">Build your own bundle</a></div></div>';
    swap(html);
    prices();
    if (window.npRatings) window.npRatings.fill(main);
    var h = main.querySelector(".nq-rtitle");
    if (h) h.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }

  /* prices, total and the subscription note follow the plan and flavour picks */
  function prices() {
    var now = 0, was = 0, off = 0;
    ids.forEach(function (k) {
      var v = variantFor(k), sub = subOn(k), el = main.querySelector('[data-price="' + k + '"]');
      var pNow = sub ? v.sp : v.p;
      now += pNow; was += v.p;
      if (st.plan === "sub" && !sub) off++;
      if (el) el.innerHTML = '<span>' + money(pNow) + '</span>' + (sub && v.sp < v.p ? '<s>' + money(v.p) + '</s>' : '');
    });
    var subTot = st.plan === "sub" && now < was;
    var totLabel = st.plan === "sub" ? "Stack total · per month" : "Stack total";
    document.getElementById("nq-totlabel").textContent = totLabel;
    document.getElementById("nq-totnum").innerHTML = money(now) + (subTot ? '<s>' + money(was) + '</s>' : '');
    var status = document.getElementById("nq-total-status");
    if (status) status.textContent = totLabel + ": " + money(now) + (subTot ? " (was " + money(was) + ")" : "");
    var note = document.getElementById("nq-note");
    note.hidden = !off;
    if (off) note.textContent = off === 1 ? "One product in this stack is not on subscription, so it is added as a one-time purchase." : off + " products in this stack are not on subscription, so they are added as one-time purchases.";
  }

  function addStack(btn) {
    var items = ids.map(function (k) {
      var v = variantFor(k), it = { id: v.id, quantity: 1 };
      if (subOn(k)) it.selling_plan = P[k].plan;
      return it;
    }).filter(function (it) { return it.id; });
    if (!items.length) return;
    var prevLabel = btn.textContent;
    btn.textContent = "Adding…";
    var request = window.npCart
      ? window.npCart.add(items, { button: btn })
      : Promise.reject(new Error("Please try again"));
    request
      .then(function () {
        btn.textContent = "Added to cart ✓";
      })
      .catch(function (err) {
        btn.textContent = prevLabel;
        var note = document.getElementById("nq-note");
        if (note) {
          note.hidden = false;
          note.textContent = (err && err.message) || "Something went wrong adding the stack. Please try again.";
        }
      });
  }

  function render(focus) {
    clearTimeout(advT);
    if (st.step < 0) renderIntro(focus);
    else if (st.step < Q.length) renderQ(focus);
    else renderResult();
  }
  function pick(v) {
    var q = Q[st.step];
    if (q.multi) {
      var cur = (st.ans[q.id] || []).slice(), i = cur.indexOf(v);
      if (i > -1) cur.splice(i, 1); else { cur.push(v); cur = cur.slice(-q.multi); }
      st.ans[q.id] = cur;
      main.querySelectorAll(".nq-a").forEach(function (b) { b.setAttribute("aria-pressed", cur.indexOf(b.getAttribute("data-v")) > -1 ? "true" : "false"); });
      var nx = main.querySelector(".nq-next");
      if (nx) nx.disabled = !cur.length;
      return;
    }
    st.ans[q.id] = v;
    main.querySelectorAll(".nq-a").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-v") === v ? "true" : "false"); });
    var nx2 = main.querySelector(".nq-next");
    if (nx2) nx2.disabled = false;
    if (autoAdv) { clearTimeout(advT); advT = setTimeout(next, 260); }
  }
  function next() { st.step = Math.min(st.step + 1, Q.length); render(true); }
  function back() { st.step = Math.max(st.step - 1, introOn ? -1 : 0); render(true); }

  main.addEventListener("click", function (e) {
    var a = e.target.closest(".nq-a");
    if (a) { pick(a.getAttribute("data-v")); return; }
    var pl = e.target.closest(".nq-plan");
    if (pl) {
      st.plan = pl.getAttribute("data-plan");
      main.querySelectorAll(".nq-plan").forEach(function (b) { b.setAttribute("aria-pressed", b === pl ? "true" : "false"); });
      prices();
      return;
    }
    var act = e.target.closest("[data-act]");
    if (!act) return;
    var k = act.getAttribute("data-act");
    if (k === "start") { st.step = 0; render(true); }
    else if (k === "next") next();
    else if (k === "back") back();
    else if (k === "restart") { st = { step: 0, ans: {}, plan: "sub", pick: {} }; render(true); }
    else if (k === "add") addStack(act);
  });
  main.addEventListener("change", function (e) {
    var s = e.target.closest("select[data-k]");
    if (!s) return;
    st.pick[s.getAttribute("data-k")] = Number(s.value);
    prices();
  });
  /* keyboard shortcuts only act while the quiz has focus (or nothing does) */
  window.addEventListener("keydown", function (e) {
    var t = e.target;
    if (!(t === document.body || nqRoot.contains(t))) return;
    if (t && (t.tagName === "INPUT" || t.tagName === "SELECT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (st.step < 0 || st.step >= Q.length) return;
    var i = KEYS.indexOf((e.key || "").toUpperCase());
    if (i > -1 && Q[st.step].a[i]) { e.preventDefault(); pick(Q[st.step].a[i].v); return; }
    if (e.key === "Backspace") { e.preventDefault(); back(); return; }
    /* a focused button already advances via its own native Enter-activation
       (it dispatches a click, which the delegated click handler picks up),
       so only handle Enter ourselves when focus is elsewhere — e.g. on the
       step heading, or nowhere, right after picking answers with the letter
       keys above. */
    if (e.key === "Enter" && t.tagName !== "BUTTON" && Q[st.step].multi && (st.ans[Q[st.step].id] || []).length) { e.preventDefault(); next(); }
  });

  /* the intro is already correct in the DOM (introHTML above); only render
     when we start somewhere past it. */
  if (st.step >= 0) render(false);
})();
